

























































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Team } from '@/models'
import { Utils } from '@/utils'
import UpsertTeamModal from '@/components/modals/UpsertTeamModal.vue'

@Component({
  components: { UpsertTeamModal }
})
export default class Teams extends Vue {
  private teams: Team[] = []
  private loading = false
  private searchFilter = ''
  private selectedTeam: Team = { id: 0, name: '', responsibleId: '' }

  private fields = [
    { key: 'id', label: 'ID', sortable: true },
    { key: 'name', label: this.$t('teams_view.columns.name'), sortable: true },
    { key: 'responsibleId', label: this.$t('teams_view.columns.responsible'), sortable: true },
    { key: 'createdOn', label: this.$t('teams_view.columns.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredTeams(): Team[] {
    if (!this.searchFilter.trim()) return this.teams
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.teams.filter(team => {
      const name = Utils.normalizeText(team.name)
      const responsible = Utils.normalizeText(team.responsibleId)
      return name.includes(filterNormalized) || responsible.includes(filterNormalized)
    })
  }

  async created() {
    await this.loadTeams()
  }

  async loadTeams() {
    try {
      this.loading = true
      this.teams = await ApiClient.getTeams()
    } catch (error) {
      console.error('Error loading teams:', error)
      this.$bvToast.toast(this.$t('teams_view.error_loading').toString(), {
        title: this.$t('teams_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedTeam = { id: 0, name: '', responsibleId: '' }
    this.$nextTick(() => this.$bvModal.show('UpsertTeamModal'))
  }

  openEditModal(team: Team) {
    this.selectedTeam = { ...team }
    this.$nextTick(() => this.$bvModal.show('UpsertTeamModal'))
  }

  async onTeamSaved() {
    await this.loadTeams()
    this.$bvToast.toast(this.$t('teams_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }

  async confirmDelete(team: Team) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      this.$t('teams_view.confirm_delete', { name: team.name }).toString(),
      {
        title: this.$t('teams_view.confirm_delete_title').toString(),
        okVariant: 'danger',
        okTitle: this.$t('button_actions.remove').toString(),
        cancelTitle: this.$t('button_actions.cancel').toString(),
        centered: true
      }
    )

    if (!confirmed) return

    try {
      await ApiClient.deleteTeam(team.id)
      this.$bvToast.toast(this.$t('teams_view.deleted_success').toString(), {
        title: this.$t('feedback.feedback_message_success_title').toString(),
        variant: 'success',
        solid: true
      })
      await this.loadTeams()
    } catch (error: any) {
      console.error('Error deleting team:', error)
      this.$bvToast.toast(error.message || this.$t('teams_view.error_deleting').toString(), {
        title: this.$t('teams_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    }
  }
}
